import React, { useState } from "react";

export default function BulkFreight() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
      form.reset();
      setTimeout(() => setDone(false), 3000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ INLINE CSS */}
      <style>{`
        .banner {
          height: 350px;
          background: url('/slider3.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
        }

        .banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .banner h1 {
          z-index: 2;
          font-size: 48px;
          font-weight: 800;
        }

        .section {
          padding: 90px 0;
        }

        .glass-card {
          background: rgba(255,255,255,0.92);
          padding: 45px;
          border-radius: 22px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.12);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(0,0,0,0.08);
          animation: fadeUp 1s ease;
          margin-bottom: 60px;
        }

        .title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 20px;
          position: relative;
        }

        .title::after {
          content: "";
          width: 120px;
          height: 5px;
          background: linear-gradient(90deg, #005eff, #f80b0b);
          position: absolute;
          bottom: -8px;
          left: 0;
          border-radius: 5px;
        }

        .text {
          font-size: 17px;
          color: #444;
          line-height: 1.85;
          margin-bottom: 18px;
        }

        .feature-box {
          padding: 22px;
          border-radius: 18px;
          background: white;
          border-left: 6px solid #005eff;
          box-shadow: 0px 10px 25px rgba(0,0,0,0.12);
          margin-bottom: 22px;
        }

        .bulk-form {
          margin-top: 70px;
          background: white;
          padding: 45px;
          border-radius: 22px;
          box-shadow: 0px 20px 45px rgba(0,0,0,0.12);
          animation: fadeUp 1s ease;
        }

        .form-label {
          font-weight: 600;
          color: #222;
        }

        .form-control-custom,
        .form-select-custom {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #cfd6ff;
          font-size: 15px;
          transition: 0.25s ease;
        }

        .form-control-custom:focus,
        .form-select-custom:focus {
          border-color: #005eff;
          box-shadow: 0 0 8px rgba(0,94,255,0.35);
        }

        .submit-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(90deg, #005eff, #003fc8);
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          border: none;
          border-radius: 14px;
          transition: .3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0px 12px 22px rgba(0,94,255,0.35);
        }

        .loading-text {
          margin-top: 12px;
          color: #005eff;
          font-weight: 600;
        }

        .success-text {
          margin-top: 12px;
          color: green;
          font-weight: 600;
        }

        .faq-box {
          background: #f4f7ff;
          padding: 18px;
          border-radius: 12px;
          border-left: 4px solid #005eff;
          margin-bottom: 15px;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="banner">
        <h1>Bulk Freight Delivery</h1>
      </div>

      {/* ⭐ MAIN CONTENT */}
      <section className="section">
        <div className="container">

          {/* ⭐ INTRO */}
          <div className="glass-card">
            <h2 className="title">Heavy-Duty, Large-Scale & Industrial Freight Transportation</h2>

            <p className="text">
              When your business needs to move high-volume, oversized, or heavy cargo across the 
              United States — you need a logistics partner capable of handling complexity, 
              scale, and precision.  
              <br /><br />
              SWIFTSHIP specializes in Bulk Freight Delivery designed for industries that require 
              safe, cost-efficient, and time-sensitive transportation of large shipments.
            </p>

            <p className="text">
              Our bulk freight network includes nationwide trucking carriers, rail logistics, 
              intermodal transport, industrial forklifts, palletized movement, and specialized 
              heavy-load equipment.  
              <br />
              Whether you're shipping **construction materials, machinery, automotive components, 
              raw materials, or large pallet loads**, our freight team ensures your cargo arrives 
              safely, securely, and on time.
            </p>

            <p className="text">
              With end-to-end handling, real-time tracking, route optimization, and compliance 
              management — SWIFTSHIP delivers bulk logistics with unmatched reliability and accuracy.
            </p>
          </div>

          {/* ⭐ SERVICES */}
          <h2 className="title">Bulk Freight Services We Provide</h2>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Full Truckload (FTL) Transport</h5>
            <p className="text">
              Dedicated truck capacity ideal for large-volume shipments, single-destination loads, 
              and time-critical industrial freight.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Less-Than-Truckload (LTL) Consolidation</h5>
            <p className="text">
              Cost-effective for bulk cargo that does not require an entire truck. Ideal for palletized 
              shipments moving regionally or cross-country.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Intermodal & Rail Freight</h5>
            <p className="text">
              Integrated rail + truck movement for long-distance heavy freight — lowering cost while 
              providing stable, high-capacity transport.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Oversized & Heavy-Haul Freight</h5>
            <p className="text">
              Transportation solutions for machinery, industrial parts, construction equipment, and 
              other oversized loads requiring special permits or escorts.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Bulk Pallet Shipping</h5>
            <p className="text">
              Ideal for FMCG, wholesale, automotive, and manufacturing companies moving 10–500 pallets 
              nationwide or internationally.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Freight Optimization & Route Planning</h5>
            <p className="text">
              Our AI-driven routing reduces transport time, fuel cost, and idle delays — ensuring the 
              most efficient delivery path every time.
            </p>
          </div>

          {/* ⭐ INDUSTRIES */}
          <h2 className="title mt-5">Industries That Rely on Our Bulk Freight Services</h2>

          <ul className="text">
            <li>✔ Construction & Infrastructure</li>
            <li>✔ Automotive Manufacturing</li>
            <li>✔ Industrial Machinery Transport</li>
            <li>✔ Agriculture, Grains & Raw Materials</li>
            <li>✔ Chemicals & Bulk Liquids</li>
            <li>✔ Retail Distribution & Wholesale</li>
            <li>✔ Food & Beverage Pallet Shipping</li>
            <li>✔ Heavy Equipment & Hardware</li>
          </ul>

          {/* ⭐ FAQ SECTION */}
          <h2 className="title mt-5">Bulk Freight Delivery FAQs</h2>

          <div className="faq-box">
            <strong>Q: What is considered a bulk freight shipment?</strong>
            <p className="text">
              Any shipment that requires palletized, heavy-load, oversized, or large-volume transportation.
            </p>
          </div>

          <div className="faq-box">
            <strong>Q: Can SWIFTSHIP handle oversized permits?</strong>
            <p className="text">Yes — we manage permits, escorts, routing, and safety compliance.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Do you offer real-time tracking?</strong>
            <p className="text">Yes — GPS, milestone updates, and delivery notifications included.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Can you ship bulk freight internationally?</strong>
            <p className="text">Absolutely — we support cross-border and ocean freight bulk transport.</p>
          </div>

          {/* ⭐ HIGH-CONVERSION FORM */}
          <form className="bulk-form" onSubmit={handleSubmit}>
            <h3 className="fw-bold mb-4">Request a Bulk Freight Quote</h3>

            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label">Full Name</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Freight Type</label>
                <select className="form-select-custom" required>
                  <option value="">Select Type</option>
                  <option>Full Truckload (FTL)</option>
                  <option>Less-Than-Truckload (LTL)</option>
                  <option>Intermodal / Rail</option>
                  <option>Oversized / Heavy Haul</option>
                  <option>Bulk Pallet Shipment</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Pickup Location</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Delivery Destination</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-12">
                <label className="form-label">Describe Your Bulk Cargo</label>
                <textarea className="form-control-custom" rows="4" required></textarea>
              </div>

            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Request"}
            </button>

            {loading && <div className="loading-text">Please wait...</div>}
            {done && <div className="success-text">Your bulk freight request has been submitted successfully!</div>}
          </form>

        </div>
      </section>
    </>
  );
}
